import { ScrollProgress } from './scroll-progress';
import { SectionRail } from './section-rail';
import { Header } from './header';
import { Hero } from './hero';
import { Philosophy } from './philosophy';
import { InOneLine } from './in-one-line';
import { Concept } from './concept';
import { DecisionUnitUnboxer } from './decision-unit';
import { HowItWorks } from './how-it-works';
import { TransitionTypes } from './transition-types';
import { Deliverables } from './deliverables';
import { PredecessorChat } from './predecessor-chat';
import { TrustStrip } from './trust-strip';
import { CaseStudy } from './case-study';
import { SavingsCalculator } from './savings-calculator';
import { PricingSection } from './pricing-section';
import { FAQ } from './faq';
import { FinalCta } from './final-cta';
import { Footer } from './footer';

export default function Landing() {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <ScrollProgress />
            <SectionRail />
            <Header />
            <Hero />
            <Philosophy />
            <InOneLine />
            <TrustStrip />
            <Concept />
            <DecisionUnitUnboxer />
            <HowItWorks />
            <TransitionTypes />
            <Deliverables />
            <PredecessorChat />
            <CaseStudy />
            <SavingsCalculator />
            <PricingSection />
            <FAQ />
            <FinalCta />
            <Footer />
        </div>
    );
}
